import React from "react";
import useAuth from "../../hooks/useAuth";
import MainLayout from "../Common/MainLayout";

/**
 * SmartRoute - Conditionally renders based on authentication state
 * - Authenticated users: Renders MainLayout (which includes TopHeader, Sidebar, etc.)
 * - Unauthenticated users: Renders the public component
 *
 * This allows the same URL to show different content based on auth state
 * while ensuring authenticated users always see the full layout with navigation
 */
const SmartRoute = ({ publicComponent }) => {
    const { auth } = useAuth();

    // If user is authenticated, show MainLayout (which has its own routing)
    if (auth?.accessToken) {
        return <MainLayout />;
    }

    // For unauthenticated users, show the public component
    return publicComponent;
};

export default SmartRoute;
